<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :title="$t('SeaExport.OutboundConfirmation')"
      width="450px"
      append-to-body
      class="app-main-inner"
    >
      <el-form label-width="120px" label-position="left" style="width: 80%;margin-bottom: 20px;margin-left: 20px">
        <el-form-item :label="$t('SeaExport.CargoVehicle')">
          <el-input v-model="pickingOrder.deliveryVehicle" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Driver')">
          <el-input v-model="pickingOrder.driver" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Phone')">
          <el-input v-model="pickingOrder.tel" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Consignee')">
          <el-input v-model="pickingOrder.consignee" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.DeliveryTime3')">
          <el-date-picker v-model="pickingOrder.deliveryTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.OutboundUser')">
          <el-input v-model="pickingOrder.outboundUser" />
        </el-form-item>
        <el-form-item :label="$t('Warehouse.DeliveryDate')">
          <el-date-picker v-model="pickingOrder.outboundTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.OutboundRemarks')">
          <el-input v-model="pickingOrder.outboundRemarks" type="textarea" />
        </el-form-item>
      </el-form>
      <div style="text-align:left;flex:1;margin-bottom:10px;margin-left: 20px">
        <el-form class="spacing">
          <el-upload
            :action="`${URL.warehouseIn.uploadFileForPickingOrder}?saveFile=false&pickingOrderKey=${pickingOrder.uuid}`"
            :headers="{sessionId:$store.getters.token}"
            :show-file-list="false"
            :on-success="uploadSuccess"
            :on-change="toChooseFile"
            style="display: inline-block;margin-right: 5px;"
          >
            <el-button type="primary" size="mini">{{ $t('SeaExport.Upload') }}</el-button>
          </el-upload>
          <el-button type="danger" size="mini" @click="delPhotoHandler">{{ $t('SeaExport.Remove') }}</el-button>
        </el-form>
      </div>
      <cargo-ag-grid
        :grid-options="gridOptions"
        :grid-params.sync="gridParams"
        :column-defs="columnDefs"
        :row-data="documentList"
        style="width:85%;margin-left: 20px"
        @gridReady="params=>{gridApi=params.api}"
      />
      <span slot="footer">
        <el-button type="primary" size="mini" @click="confirmOutbound">{{ $t('SeaExport.Save') }}</el-button>
        <el-button size="mini" @click="close">{{ $t('SeaExport.Close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 预览文件弹窗 -->
    <pre-view-file-dialog
      :v-if="previewFileData.visible"
      no="preview"
      :title="$t('FileHistory.preview')"
      :visible="previewFileData.visible"
      :file="previewFileData.file"
      :can-maximize="true"
      @close="closePreviewDialog"
    />
  </div>
</template>

<script>

import { DocumentManage } from '@/utils/commonUtil'
import preViewFileDialog from '@/components/Cargo/Common/preViewFileCommonDialog'
import URL from '@/api/urlTranslator'
import { outboundConfirm, pickingOrderDetail } from '@/api/warehouseIn/warehouseIn'
import { getLoading4Cxt } from '@/utils/utilBaseElement'

export default {
  name: 'OutboundConfirmDialog',
  components: { preViewFileDialog },
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [
        {
          headerName: ' ', maxWidth: 30, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FileName'),
          colId: 'fileName',
          field: 'fileName',
          width: 200
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: 'documentId',
          width: 200,
          cellRenderer: params => {
            return `<a onclick="${this.documentManage.getPath('handlePreviewFile')}('${params.value}')" style="color:blue">${this.$t('FileHistory.preview')}</a>`
          }
        }
      ],
      URL: URL,
      innerVisible: false,
      documentList: [], // 文件列表
      pickingOrder: {
        uuid: '',
        pickingOrderUuid: '',
        deliveryVehicle: '',
        driver: '',
        tel: '',
        outboundRemarks: '',
        consignee: '',
        deliveryTime: '',
        outboundUser: '',
        outboundTime: '',
        documentList: [],
        detailList: []
      },
      documentManage: new DocumentManage(),
      // 图片预览参数
      previewFileData: {
        visible: false,
        file: null
      }
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('handlePreviewFile', function(value) {
      context.handlePreviewFile(value)
    })
  },
  methods: {
    async onShow(pickingOrderKey = null) {
      if (pickingOrderKey) {
        this.loading = getLoading4Cxt()
        pickingOrderDetail({ pickingOrderKey: pickingOrderKey }).then(res => {
          if (res.data) {
            this.pickingOrder = res.data
            const documentList = []
            if (this.pickingOrder.businessDocuments) {
              for (const item of this.pickingOrder.businessDocuments) {
                documentList.push({ ...item })
              }
            }
            this.documentList = documentList
          }
        }).finally(res => {
          this.loading.close()
        })
      }
    },
    async handlePreviewFile(value) {
      const fileObject = this.documentList.find(x => x.documentId === value)
      this.previewFileData.file = { ...fileObject, fileId: fileObject.documentId }
      this.previewFileData.visible = true
    },
    closePreviewDialog() {
      this.previewFileData.file = null
      this.previewFileData.visible = false
    },
    toChooseFile(file) {
      if (file.size > 20 * 1024 * 1024) {
        this.$message.warning(this.$t('Message.TheExceeds20MBAndUploaded'))
        return
      }
    },
    // 上传成功
    uploadSuccess(response, file, fileList) {
      if (response && response.data) {
        const document = {}
        document.uuid = ''
        document.businessId = response.data.businessId
        document.createdBy = response.data.createdBy
        document.dateCreated = response.data.dateCreated
        document.documentCategory = response.data.documentCategory
        document.documentId = response.data.documentId
        document.fileName = response.data.fileName
        document.fileSize = response.data.fileSize
        document.fileType = response.data.fileType
        document.fileCategory = response.data.fileCategory
        document.newData = true
        this.documentList.push(document)
      } else {
        this.$message.warning(this.$t('Message.UploadPleaseContactTheAdministrator'))
      }
    },
    // 删除文件
    delPhotoHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      for (const row of rows) {
        const index = this.documentList.indexOf(row)
        this.documentList.splice(index, 1)
      }
    },
    // 确认出仓
    confirmOutbound() {
      this.loading = getLoading4Cxt()
      this.pickingOrder.pickingOrderUuid = this.pickingOrder.uuid
      this.pickingOrder.documentList = this.documentList
      outboundConfirm(this.pickingOrder).then(res => {
        if (res.ok) {
          this.$message.success(this.$t('SeaExport.WarehouseConfirmationSuccessful'))
          this.innerVisible = false
          this.$emit('refresh')
        }
      }).finally(res => {
        this.loading.close()
      })
    },
    close() {
      this.innerVisible = false
    }
  }
}
</script>
<style lang="scss">
</style>
